enum InvoiceTaxType {
  GSTOnIncome = 'GSTOnIncome',
  GSTFree = 'GSTFree',
  BASExcluded = 'BASExcluded',
  NoVAT = 'NoVAT'
}

export default InvoiceTaxType;
